import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';

export type EchartsBarFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormColumn[];
    metric?: string;
    showLabels: boolean;
    combineMetrics: boolean;
    colorScheme?: string;

    metrics: QueryFormMetric[];

    enableDrillDown: boolean;
    // subQueryGroupby: QueryFormData[] & QueryFormColumn[],
    // subQueryMetrics: QueryFormMetric[]
};

export interface EchartsBarChartProps
  extends ChartProps<EchartsBarFormData> {
  formData: EchartsBarFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsBarFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  combineMetrics: false,
//   numberFormat: 'SMART_NUMBER',
//   emitFilter: false,

  enableDrillDown: false,
  // subQueryGroupby: [],
  // subQueryMetrics: []
}

export interface BarChartTransformedProps {
  formData: EchartsBarFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];

  // drillDownGroupby: QueryFormColumn[];
  // enableDrillDown: boolean;
  // drillDownMetrics: QueryFormMetric[];
}